import { Accessor, createMemo, onMount } from "solid-js";

import { RNREvent } from "~/data/events";
import { useAnalyticsService } from "~/context/analytics_service_context";
import { BrandL2TelescopeRouteData } from "../data/brand_l2_telescope_route_data";
import { useWebStoreContext } from "~/context/webstore_context";
import { useRnrPayment } from "~/hooks/use_rnr_payment";
import { useOnecardPayment } from "~/views/webstore/brandl2_onecard/hooks/use_onecard_payment";
import { clientIdConfig } from "~/data/partner_config";

export function useRnrBrandPage(brandPageProps: {
  brandKey: string;
  routeData: Accessor<BrandL2TelescopeRouteData | undefined>;
}) {
  const { routeData } = brandPageProps;
  const analyticsService = useAnalyticsService();
  const { storeState, getClientId } = useWebStoreContext();

  const brand = createMemo(() => routeData()?.brand);

  onMount(() => {
    analyticsService.logEvent(RNREvent.VISIT_BRANDL2_PAGE, {
      brandName: brand()?.name.toLowerCase(),
    });
  });

  const paymentHook =
    getClientId() === clientIdConfig.onecardClientId
      ? useOnecardPayment
      : useRnrPayment;

  const { onClickGetThisCard, ctaState, setCtaState } = paymentHook({
    brand: () => brand()!,
    brandKey: brand()!.brandKey,
  });

  return {
    routeData,

    isLoggedIn: storeState.isLoggedIn,
    onClickGetThisCard,
    ctaState,
    setCtaState,
    // redemptionControls moved to denomination grid
  };
}

// animateDueAmount moved to denomination grid internal hook
